import styled from 'styled-components/macro';

export const CharCounter = styled.span<{ isMaxLengthReached?: boolean }>`
  display: flex;
  align-items: center;
  position: absolute;
  bottom: 12px;
  right: 12px;
  pointer-events: none;

  padding: 0 4px;
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(2px);
  border-radius: 4px;

  z-index: 2;

  font-size: 12px;
  line-height: 24px;
  color: ${({ isMaxLengthReached, theme }) =>
    theme.colors[isMaxLengthReached ? 'danger' : 'neutral'][100]};
`;
